"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FamilyContract = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var FamilyContract = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(FamilyContract, _super);
    function FamilyContract() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷家庭联系人关系接口';
        _this.code = '101123';
        _this.desc = '现金贷家庭联系人关系接口';
        _this.requestParams = new cashLoanAuth_1.FamilyContractRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return FamilyContract;
}(service_1.BaseService));
exports.FamilyContract = FamilyContract;
//# sourceMappingURL=familyContract.js.map